import React from 'react';
import classnames from 'classnames';
import crossImage from 'assets/svg/cross.svg';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import { instantScrollTop } from 'swag-client-common/utils/tricks';
import classes from '../single-view-design-upload.scss';
export const SingleViewDesignLogo = ({
  logo,
  isLimitedEdition,
  isMobileView,
  shouldShowDetectedColorsCount,
  showRemoveLogoButton,
  view,
  onViewNameClick,
  onLogoEditColors,
  onLogoDelete
}) => {
  const {
    id,
    originalFileName,
    colors
  } = logo;
  const handleLogoDelete = (e, id) => {
    e.preventDefault();
    onLogoDelete(id);
  };
  const handleViewNameClick = () => {
    if (isMobileView) {
      instantScrollTop();
    }
    onViewNameClick();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.container, {
      [classes.orangeContainer]: isLimitedEdition
    }),
    "data-colors": colors ? colors.colorsToPrint.join(',') : ''
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.row, {
      [classes.withoutDetectedColorsCount]: !shouldShowDetectedColorsCount
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.leftData, {
      [classes.hideLeftData]: shouldShowDetectedColorsCount
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.pinkLabel, classes.actionable, classes.leftDataName, {
      [classes.orangeLabel]: isLimitedEdition
    }),
    onClick: handleViewNameClick
  }, view.name), shouldShowDetectedColorsCount && /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.greyLabel, classes.fileNameLabel)
  }, originalFileName)), /*#__PURE__*/React.createElement("div", {
    className: classes.logoActions
  }, shouldShowDetectedColorsCount && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.pinkLabel, classes.colorsDetectedLabel),
    onClick: () => onLogoEditColors(logo)
  }, `${colors.colorsNumber} color${colors.colorsNumber > 1 ? 's' : ''}`), /*#__PURE__*/React.createElement("div", {
    onClick: () => onLogoEditColors(logo),
    className: classnames(classes.greyLabel, classes.editColorsButton)
  }, "Edit")), !shouldShowDetectedColorsCount && /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.greyLabel, classes.fileNameLabel)
  }, originalFileName), showRemoveLogoButton && /*#__PURE__*/React.createElement("div", {
    className: classes.fileNames
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.marginRow, classes.singleLogoAction)
  }, /*#__PURE__*/React.createElement("img", {
    src: crossImage,
    className: classes.icon,
    onClick: e => handleLogoDelete(e, id),
    tabIndex: 0,
    onKeyDown: e => handleOnEnterPressed(e, () => handleLogoDelete(e, id)),
    "aria-label": `Remove ${view.name} design`
  }))))));
};